<template>
  <div class="tzModal" :class="{ 'tzModal--close': !open }">
    <button class="tzModal__close-btn" @click.prevent="handleCloseModal">
      X
    </button>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'TzModal',
  props: {
    open: {
      type: Boolean
    }
  },
  methods: {
    handleCloseModal() {
      this.$emit('tz-modal-close');
    }
  }
};
</script>
